import { request } from "../../httpClient";

export const getGalleryRequest = async (id) => {
  const res = await request({
    path: `vehicle-gallery/list?vehicle_id=${id}`,
  });
  return res;
};
